<template>
  <div class="wrap-patient-database">
    <tab-nav :tab-pane-list="tabPaneList" />
  </div>
</template>

<script>
import tabNav from '@/components/tab-nav.vue' // 评分量表
export default {
  components: {
    tabNav
  },
  data() {
    return {
      tabPaneList: [
        {
          id: '0',
          label: '总体概览',
          route: '/analysis/overview'
        }, {
          id: '1',
          label: '内容分析',
          route: '/analysis/content'
        }, {
          id: '2',
          label: '评论分析',
          route: '/analysis/comment'
        }, {
          id: '3',
          label: '达人画像',
          route: '/analysis/guruImage'
        }
      ]
    }
  }
}
</script>

<style lang="less">
.wrap-overview,
.wrap-content-anlysis,
.wrap-comment,
.wrap-guruImage{
  padding: 0;
  & .list-filter-wrap-box{
    position: fixed;
    top: 39px;
    width: calc(~'100vw - 215px');
    background-color: #F5F5F5;
    padding: 15px;
    z-index: 9;
    & .list-fliter-wrap{
      background-color: #fff;
    }
  }
  & .wrap-main-content{
    padding: 15px;
    margin-top: 100px;
  }
}
.wrap-content-anlysis .wrap-main-content{
  margin-top: 150px;
}
</style>

<style lang="less" scoped>
</style>
